module.exports = __webpack_public_path__ + "img/code.b0ba9406.svg";